import React from 'react';
import { compose, mapProps } from 'recompose';
import { graphql } from 'react-apollo';

import CircularBadge from 'components/common/Badge/CircularBadge';
import { INITIALS, getFormattedName } from 'selectors/formatName/selector';
import { getColorForName } from 'selectors/nameColor/selector';
import { isCurrentUser as isCurrentUserSelector } from 'selectors/user/selector';
import { getCurrentUser } from 'graphql/operations';

import './UserBadge.scss';

export const UserBadge = props => {
  const { color, badgeStyle, noName, initials, isCurrentUser, name, isOnline } = props;
  return (
    <div className={!noName ? 'user-badge' : 'user-badge hide'}>
      <CircularBadge
        isOnline={isOnline}
        value={initials}
        className={isCurrentUser ? 'current-user' : ''}
        style={{ backgroundColor: color, ...badgeStyle }}
      />
      {!noName && (
        <div className="name" style={{ marginLeft: '0.5rem' }}>
          {name}
        </div>
      )}
    </div>
  );
};

export const UserBadgeHOC = compose(
  graphql(getCurrentUser, { name: 'getCurrentUser' }),
  mapProps(props => ({
    isOnline: props.isOnline,
    noName: props.noName,
    isCurrentUser: isCurrentUserSelector(props),
    name: getFormattedName(props),
    initials: getFormattedName({ ...props, format: INITIALS }),
    color: getColorForName(props),
    badgeStyle: props.badgeStyle
  }))
);

export default UserBadgeHOC(UserBadge);
